import { DriverTypes, UserOs } from '../store/Constants'

/**
 * Attempt to open download software driver for a given SKU.
 * Behaviour:
 *  - If migrationFlag === true: use 123 API flow (cache + fetchBasicDrivers) (new behaviour)
 *  - Else: fallback to legacy SWLS driver preference list via swlsClient.getDriverDownloadUrl
 * Preference order for fallback:
 *  - Windows: win_sw_setup_integrated -> win_sw_setup -> fullkarnak
 *  - Mac: mac_sw_setup
 * Returns true if navigation triggered, false otherwise.
 */
const openSkuSoftware = async ({
  sku,
  getStoreData,
  client123,
  swlsClient,
  os,
  migrationFlag
} = {}) => {
  if (!sku) return false

  // New 123 migration path
  if (migrationFlag === true) {
    const cached = getStoreData && getStoreData('123SoftwareType')
    if (cached && cached.sku === sku && cached.softwareUrl) {
      window.location.href = cached.softwareUrl
      return true
    }
    const drivers = await client123.fetchBasicDrivers({ sku })
    const driverUrl = drivers?.data?.softwareUrl
    if (driverUrl) {
      window.location.href = driverUrl
      return true
    }
    return false
  }

  // Fallback legacy behaviour using SWLS
  if (!swlsClient) return false
  let driverTypePreference = []
  if (os === UserOs.windows) {
    driverTypePreference = [
      DriverTypes.win_sw_setup_integrated,
      DriverTypes.win_sw_setup,
      DriverTypes.fullkarnak
    ]
  } else if (os === UserOs.mac) {
    driverTypePreference = [DriverTypes.mac_sw_setup]
  }

  if (!driverTypePreference.length) return false
  try {
    const url = await swlsClient.getDriverDownloadUrl(sku, driverTypePreference)
    if (url) {
      window.location.href = url
      return true
    }
  } catch (e) {
    console.error('Fallback SWLS driver resolution failed', e)
  }
  return false
}

export default openSkuSoftware
